import { configureStore } from "@reduxjs/toolkit";
import AuthSlice from "./Slices/AuthSlices/Auth.Slice";
import UsersSlice from "./Slices/UserSlice/User.slice";
import ContentSlice from "./Slices/ContentSlice/Content.slice";
import interpreterSlice from "./Slices/InterpreterSlice/Interpreter.Slice";
import ReportSlice from "./Slices/ReportSlice/ReportSlice.Slice";
import IncompleteServiceSlice from "./Slices/IncompleteServiceSlice/IncompleteServiceSlice.Slice";
import NotificationSlice from "./Slices/NotificationSlice/NotificationSlice.slice";
import LanguageSlice from "./Slices/LanguageSlice/LanguageSlice.slice";
import DashboardSlice from "./Slices/DashboardSlice/DashboardSlice.slice";

const Store = configureStore({
    reducer: {
        AUTH: AuthSlice?.reducer,
        ALL_USERS: UsersSlice.reducer,
        ALL_CONTENTS: ContentSlice.reducer,
        ALL_INTERPRETERS: interpreterSlice.reducer,
        ALL_REPORTS: ReportSlice.reducer,
        ALL_INCOMPLETE_JOBS: IncompleteServiceSlice.reducer,
        ALL_NOTIFICATIONS: NotificationSlice.reducer,
        ALL_LANGUAGE: LanguageSlice.reducer,
        DASHBOARD_ANALAYTICS: DashboardSlice.reducer,
    }
})
export default Store;